import type {DataValue, LinkedValueLink} from '../types';
import {LinkStatuses} from '../types';
import {isData} from './isData';

export const isLinkedValueLink = (
  value: DataValue | undefined,
): value is LinkedValueLink => {
  return (
    isData(value) &&
    LinkStatuses.includes((value as LinkedValueLink).linkStatus ?? '')
  );
};
